<template>
    <div id="my_tablepanel">
        <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :row-style="tables.rowStyle || {height:'40px'}"
            :data="tables.tbody"
            :height="tabHeight || tableHeight"
            :stripe="stripe"
            border
            :summary-method="tables.summaryEvent"
            :show-summary="tables.showSummary"
            :sum-text="tables.summaryText||'合计'"
            :default-sort="tables.defaultSort"
            :empty-text="' '"
            @sort-change="sort"
            @select="rowSelectChange"
            @select-all="allSelectChange"
            @selection-change="handleSelectionChange"
            :span-method="tables.objectSpanMethod"
        >
            <div v-for="(head,hindex) in tables.thead" :key="hindex">
                <el-table-column v-if="head.expand" type="expand">
                    <template
                        slot-scope="props"
                        :prop="head.prop"
                        :label="head.label"
                        :width="head.width"
                        fixed="left"
                    >
                        <div v-if="head.type && head.type == 'table' && props.row[head.data]">
                            <el-table
                                :data="props.row[head.data]"
                                :show-header="head.showHeader"
                                :row-style="expandRowStyle"
                                style="width:100%;"
                            >
                                <div v-for="(ehead,eindex) in head.thead" :key="eindex">
                                    <el-table-column
                                        v-if="ehead.label == 'sort'"
                                        type="index"
                                        :prop="ehead.prop"
                                        :label="ehead.label"
                                        :width="ehead.width"
                                        :fixed="ehead.fixed"
                                    ></el-table-column>
                                    <el-table-column
                                        v-if="ehead.label == 'select'"
                                        type="selection"
                                        :prop="ehead.prop"
                                        :label="ehead.label"
                                        :width="ehead.width"
                                        :fixed="ehead.fixed"
                                    ></el-table-column>
                                    <el-table-column
                                        v-if="ehead.label == 'stance'"
                                        :label="ehead.label"
                                        :width="ehead.width"
                                        :fixed="ehead.fixed"
                                    ></el-table-column>
                                    <el-table-column
                                        v-if="ehead.prop"
                                        :prop="ehead.prop"
                                        :label="ehead.label"
                                        :width="ehead.width"
                                        :fixed="ehead.fixed"
                                        :align="ehead.align"
                                    >
                                        <template slot-scope="eprops">
                                            <div>
                                                <p
                                                    v-if="ehead.currency"
                                                    class="row_text"
                                                >{{eprops.row[ehead.prop] | currency}}</p>
                                                <p
                                                    v-else-if="ehead.unit"
                                                    class="row_text"
                                                >{{eprops.row[ehead.prop] | numberUnit}}</p>
                                                <p
                                                    v-else
                                                    class="row_text"
                                                >{{eprops.row[ehead.prop]}}</p>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        v-if="ehead.label == 'expand'"
                                        :width="ehead.width"
                                        :fixed="ehead.fixed"
                                    ></el-table-column>
                                </div>
                            </el-table>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="(head.name === '序号' || head.name === 'sort') && !head.attr"
                    type="index"
                    label="序号"
                    :width="head.width || '60px'"
                    :fixed="hindex === 0 ? 'left' : head.fixed"
                    align="center"
                ></el-table-column>
                <el-table-column
                    v-if="head.name === '选择' || head.name === 'select'"
                    type="selection"
                    :width="head.width || '50px'"
                    :fixed="hindex === 0 ? 'left' : head.fixed"
                    align="center"
                ></el-table-column>
                <el-table-column v-if="head.iconfont" :label="head.name">
                    <template slot-scope="{row}">
                        <span
                            class="icon iconfont-1"
                            v-html="row[head.attr]"
                            style="font-size: 20px;"
                        ></span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else-if="head.attr"
                    :prop="head.attr"
                    :sortable="head.sort"
                    :label="head.name"
                    :width="head.width"
                    :fixed="hindex === 0 ? 'left' : head.fixed"
                    :align="head.align || 'left'"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div v-if="head.img && head.type != 'fileLs'">
                            <img
                                style="width:40px;height:40px"
                                :src="gFileUrl+scope.row[head.attr]"
                            />
                        </div>
                        <div
                            v-else-if="head.event"
                            class="row_event_text"
                            @click="head.event(scope.row)"
                        >
                            <p
                                v-if="head.filter"
                                class="row_text"
                            >{{scope.row[head.attr] | switchType(head.filter[0],head.filter[1])}}</p>
                            <p
                                v-else-if="head.currency"
                                class="row_text"
                                :style="head.style?head.style:{}"
                            >{{scope.row[head.attr] | currency}}</p>
                            <p
                                v-else-if="head.unit"
                                class="row_text"
                                :style="head.style?head.style:{}"
                            >{{scope.row[head.attr] | numberUnit}}</p>
                            <p v-else class="row_text">{{head.format ? head.format(scope.row[head.attr],scope.row) : scope.row[head.attr]}}</p>
                        </div>
                         <span v-else-if="head.type == 'fileLs'" style="display: flex; justify-content: center">
                                <div
                                    v-if="Array.isArray(scope.row[head.attr]) && scope.row[head.attr].length"
                                    style="display: flex;max-width: 100%;"
                                >
                                <img :src="getImg(scope.row[head.attr])" alt="" v-if="head.img" style="height: 50px;"/>
                                <span v-else>
                                    <span  v-for="(head, key) in scope.row[head.attr]" :key="key" style="display: flex;max-width: 100%;" >
                                    <span class="company" @click="downLoad(head)" style="width:100px" :title="head.fileName">
                                        {{ head.fileName }}
                                    </span>
                                    <el-button size="mini" type="text" @click="lookup(head)">查看</el-button>
                                    </span>
                                </span>
                                    
                                </div>
                        </span>
                        <div  v-else-if="head.tag">
                            <el-tag size="small" :type="head.getType && head.getType(scope.row) || ''">{{head.format ? head.format(scope.row[head.attr],scope.row) : scope.row[head.attr]}}</el-tag>
                        </div>
                        <el-switch v-else-if="head.switch" v-model="scope.row[head.attr]" @change="head.switch(scope.row)" active-color="#13ce66"></el-switch>
                        <div v-else>
                            <p
                                class="row_text"
                                v-if="head.filter"
                            >{{scope.row[head.attr] | switchType(head.filter[0],head.filter[1])}}</p>
                            <p
                                v-else-if="head.currency"
                                class="row_text"
                                :style="head.style?head.style:{}"
                            >{{scope.row[head.attr] | currency}}</p>
                            <p
                          
                                v-else-if="head.format"
                                class="row_text"
                                :style="{'color' : head.color && head.color(scope.row[head.attr],scope.row)}"
                                >{{head.format(scope.row[head.attr],scope.row)}}</p>
                            <p
                                v-else-if="head.unit"
                                class="row_text"
                                :style="head.style?head.style:{}"
                            >{{scope.row[head.attr] | numberUnit}}</p>
                            <div v-else>
                                <el-popover
                                    v-if="head.hover"
                                    placement="right-start"
                                    trigger="hover"
                                    :content="(scope.row[head.attr] || '').toString()"
                                >
                                    <div slot="reference" style="cursor: pointer;">
                                        <p class="row_text">{{scope.row[head.attr]}}</p>
                                    </div>
                                </el-popover>
                                <p v-else class="row_text">{{scope.row[head.attr]}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="head.date"
                    :prop="head.date"
                    :sortable="head.sort"
                    :label="head.name"
                    :width="head.width"
                    :fixed="hindex === 0 ? 'left' : head.fixed"
                    :align="head.align"
                >
                    <template slot-scope="scope">
                        <p class="row_text">{{scope.row[head.date] | formatDate(head.format)}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="head.buttons"
                    :fixed="head.fixed || 'right'"
                    label="操作"
                    :width="head.width || '110px'"
                >
                    <template slot-scope="scope" v-if="tables.buttons">
                        <div class="clearfix" style="padding-right:10px;">
                            <span
                                v-for="(btn,index) in tables.buttons"
                                :key="index"
                                style="float:left;"
                            >
                                <div v-if="index<tabBtnNum">
                                    <span v-for="(btns, bindex) in head.buttons" :key="bindex">
                                        <template
                                            v-if="((btns.show?btns.show(scope.row,scope.$index):true) && btn.btnChart == btns.chart) || btn.showBtn"
                                        >
                                            <el-button
                                                @click="btns.event(scope.row,btn)"
                                                type="text"
                                                :style="{color:btns.btnType===4?'red':''}"
                                                size="small"
                                            >
                                                <span v-if="btns.icon" :class="btns.icon"></span>
                                                <span v-else>{{btn.name||btns.name}}</span>
                                            </el-button>
                                        </template>
                                    </span>
                                </div>
                            </span>
                            <span v-if="tables.buttons.length>tabBtnNum" class="more_buttons_box">
                                <span v-if="!tables.moreButtonsPop">
                                    <el-popover
                                    placement="left"
                                    trigger="click"
                                    :width="head.btnsWidth"
                                >
                                    <template>
                                        <div class="more_buttons">
                                            <div v-for="(btn,index) in tables.buttons" :key="index">
                                                <template v-if="index>1">
                                                    <span
                                                        v-for="(btns, bindex) in head.buttons"
                                                        :key="bindex"
                                                    >
                                                        <template
                                                            v-if="(btns.show?btns.show(scope.row,scope.$index):true) && btn.btnChart === btns.chart"
                                                        >
                                                            <el-button
                                                                @click="btns.event(scope.row,btn)"
                                                                type="text"
                                                                :style="{color:btn.btnType===4?'red':''}"
                                                                size="small"
                                                            >{{btn.name||btns.name}}</el-button>
                                                        </template>
                                                    </span>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <i class="more_buttons_icon" slot="reference"></i>
                                    </el-popover>
                                </span>
                                <span v-else>
                                    <i class="more_buttons_icon" slot="reference"></i>
                                </span>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </div>
        </el-table>
        <div class="paging" v-if="tables.showPage === false ? tables.showPage : true">
            <el-pagination
                background
                :small="true"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.current"
                :page-sizes="page.limits"
                :page-size="page.limit"
                :pager-count="5"
                layout="sizes,total,prev,pager,next,jumper"
                :total="page.total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
export default {
    name: "vTablePanel",
    props: {
        tables: {
            type: Object,
            default: function() {
                return {
                    tbody: []
                };
            }
        },
        page: {
            //翻页
            type: Object,
            default: function() {
                return {
                    limits: [10, 15, 20],
                    limit: 10,
                    current: 1,
                    total: 0
                };
            }
        },
        tableLoading: {
            //table加载loading
            type: Boolean,
            default: false
        },
        searchChange: {
            //清除选中数据
            type: Boolean
        },
        tabHeight: {
            //table高度
            type: [Number, String]
        },
        haveSearch: {
            //是否有上面的搜索来控制table的高度
            type: Boolean,
            default: true
        },
        stripe: {
            type: Boolean,
            default: true
        },
        defaultData: {
            //默认选中数据的id
            type: Array
        },
        clearUnexecuted: {
            //控制再次打开弹框时重新渲染数据
            type: Boolean
        },
        tabBtnNum: {
            type: Number,
            default: 2
        },
        defaultKey: {
            type: String,
            default: "id"
        }
    },
    data() {
        return {
            selectItems: [], //选中的数据
            defaultIds: this.defaultData || [], //默认选中的数据
            currents: [], //每一个翻页做一个标记，判断是否从新匹配数据
            gFileUrl: global.fileUrl
        };
    },
    mounted() {},
    watch: {
        "tables.tbody": {
            handler: function(val) {
                if (!this.currents[this.page.current]) {
                    this.setDefaultItem()
                }
                this.$nextTick(this.setSelectItem());
                this.currents[this.page.current] = true;
            },
            deep: true
        },
        "page.limit": function(val) {
            this.selectItems = [];
            this.currents = [];
        },
        defaultData: {
            handler: function(val) {
                this.defaultIds = val;
                this.currents = [];
                this.setDefaultItem();
                this.$nextTick(this.setSelectItem());
            },
            deep: true
        },
        clearUnexecuted: function(val) {
            if (!val) {
                this.selectItems = [];
                this.currents = [];
            }
        },
        searchChange: function(val) {
            this.selectItems = [];
        }
    },
    computed: {
        ...Vuex.mapState(["isReplaySearch"]),
        tableHeight() {
            let iHeight = this.isReplaySearch
                ? window.innerHeight - 235 - 42
                : window.innerHeight - 195 - 42;
            if (!this.haveSearch) {
                iHeight = window.innerHeight - 195 - 42;
            }
            if (this.tables.showPage === false) {
                iHeight = iHeight + 34;
            }
            return iHeight;
        }
    },
    updated() {
      this.$nextTick(()=>{
        if(!this.$refs.multipleTable) return
        this.$refs.multipleTable.doLayout();
      })
    },
    methods: {
        getImg(val){
            return global.fileUrl + val[0].fileUrl
        },
        downLoad(val) {
         window.open(global.downUrl + val.fileUrl, '_blank')
        },
        lookup(val) {
            window.open(global.fileUrl + val.fileUrl, "_blank");
        },
        expandRowStyle({ row, rowIndex }) {
            return "background-color: #FFF8DC";
        },
        sort(data) {
            if (this.tables.sortevent) {
                this.tables.sortevent(data);
            }
        },
        setDefaultItem() {
            let { defaultKey, defaultIds, selectItems } = this;
            let current = this.page.current;
            let tbody = this.tables.tbody;

            if (defaultIds.length && tbody.length) {
                tbody.forEach(val => {
                    defaultIds.forEach((v, index) => {
                        if (val[defaultKey] === v) {
                            if (selectItems[current]) {
                                if (!selectItems[current].some(item => item[defaultKey] === v)) {
                                    selectItems[current].push(val);
                                }
                            } else {
                                selectItems[current] = [];
                                selectItems[current].push(val);
                            }
                            defaultIds.splice(index, 1);
                        }
                    });
                });
            }
            
        },
        setSelectItem() {
            this.$refs.multipleTable.clearSelection();
            let { defaultKey } = this;
            let current = this.page.current;
            let exist = this.selectItems[current];
            let tbody = this.tables.tbody;
            
            if (
                exist &&
                exist.length &&
                tbody.length &&
                tbody[0][defaultKey] !== undefined
            ) {
                tbody.forEach((val, index) => {
                    exist.forEach(v => {
                        if (val[defaultKey] === v[defaultKey]) {
                            this.$nextTick(function() {
                                this.$refs.multipleTable.toggleRowSelection(tbody[index], true);
                            });
                        }
                    });
                });
            }
        },
        tableSort(data) {
            //排序
        },
        handleSizeChange(val) {
            //条数改变
            this.$emit("pageSize", val);
        },
        handleCurrentChange(val) {
            //页数改变
            this.$emit("currPage", val);
        },
        rowSelectChange(data, row) {
            //勾选数据行时触发事件
            this.selectItems[this.page.current] = data;
        },
        allSelectChange(data) {
            //勾选全选时触发事件
            this.selectItems[this.page.current] = data;
        },
        handleSelectionChange(val) {
            //选择项发生变化时触发事件
            this.$emit("selectData", this.selectItems, this.defaultIds);
        }
    }
};
</script>

<style scoped>
.paging {
    height: 32px;
    padding-top: 2px;
}
.el-table td,
.el-table th {
    font-size: 12px;
    padding: 0 !important;
}
.el-button--small,
.el-button--small.is-round {
    padding: 0 2px;
}
.more_buttons {
    width: 100%;
    background-color: #fff;
}
.more_buttons_box {
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
}
.more_buttons_icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    font-size: 16px;
    color: #409eff;
    cursor: pointer;
    background-image: url("../assets/buttons_more.png");
}
.row_event_text {
    color: #409eff;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.row_text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.el-table .expand-row {
    background-color: #ff0000;
}
.company {
  display: inline-block;
  font-family: 'Source Han Sans CN';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  color: #6a7382;
  padding: 0px 12px;
  height: 28px;
  background: #f0f3fa;
  border-radius: 30px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#my_tablepanel /deep/ .el-table--border th.gutter:last-of-type { display: block!important; width: 8px!important;height: 36px; }
</style>



// WEBPACK FOOTER //
// src/components/tablePanel.vue